import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UpdateData } from 'src/app/shared/models/update-data';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  baseUrl: string = environment.cloudUrl;
  loginUrl: string = this.baseUrl + 'password/reset';
  tokenUrl: string = this.baseUrl + 'password/expiry/token';

  constructor(private http: HttpClient) {}

  updatePassword(data: UpdateData): Observable<any> {
    const url = this.loginUrl;
    return this.http.post<UpdateData>(url, data).pipe(
      map((data) => {
        return data;
      }),
      catchError(this.handleError)
    );
  }
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = error.error;
    }
    return throwError(errorMessage);
  }
  token(id): Observable<any> {
    let checkUrl = this.tokenUrl;
    // checkUrl += '?userId=' + id;
    return this.http.post<any>(checkUrl, id).pipe(
      map((data) => {
        return data;
      }),
      catchError(this.handError)
    );
  }
  handError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = error.error;
    }
    return throwError(errorMessage);
  }
}
